import _ from "@/boot/lodash";
import { Statuses } from "@/data/status.ts";

export default function getProgressAndStatus(bulkAction) {
  const { num_successful, num_scheduled } = bulkAction;
  const progress =
    num_scheduled === 0
      ? 100
      : _.round((num_successful / num_scheduled) * 100, 2);

  const { type } = _.pick(
    _.get(Statuses, `bulkaction.${bulkAction.status.code}`),
    ["type"]
  );
  return {
    status: bulkAction.status.code,
    type,
    label: bulkAction.status.name,
    value: progress,
    ...(bulkAction.status.code === "bulk_action_incomplete"
      ? {
          status: "bulk_action_complete",
          type: _.get(Statuses, "bulkaction.bulk_action_complete.type")
        }
      : null)
  };
}
